import { render, staticRenderFns } from "./CustomUploadBox.vue?vue&type=template&id=36ac425b&scoped=true"
import script from "./CustomUploadBox.vue?vue&type=script&lang=js"
export * from "./CustomUploadBox.vue?vue&type=script&lang=js"
import style0 from "./CustomUploadBox.vue?vue&type=style&index=0&id=36ac425b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ac425b",
  null
  
)

export default component.exports